import { Button, Card, CardContent, Container, Grid, Stack, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import { AdsService } from '../../Services/ads.service'
import Iconify from '../../components/Iconify'
import Page from '../../components/Page'
import { useLoadingContext } from '../../context/loadingContext';


const EventSchema = Yup.object().shape({
    title: Yup.string().required('Tiêu đề không đươc để trống'),
    url: Yup.string().required('Url không được để trống')
});

const CreateAds = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [image, setImage] = useState();
    const [imageReview, setImageReview] = useState();
    const { handleStartLoading, handleStopLoading } = useLoadingContext();

    const defaultValues = {
        title: '',
    };

    const methods = useForm({
        resolver: yupResolver(EventSchema),
        defaultValues,
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const handleOnSubmit = (data) => {
        const form = new FormData();
        form.append('title', data.title);
        form.append('url', data.url);
        form.append('image', image);
        handleStartLoading()
        AdsService.CreateAds(form)
            .then((res) => {
                navigate('/ctkm', { replace: true, state: '/ctkm' });
                enqueueSnackbar('Thêm khuyến mại mới thành công', { variant: 'success' });
            })
            .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
            .finally(handleStopLoading)
    };

    const handleCancelClick = () => {
        navigate(-1);
    };

    const handleAvatarChange = (e) => {
        try {
            handleStartLoading()
            const img = e.target.files[0];
            const review = URL.createObjectURL(img);
            setImageReview(review);
            setImage(img);
        } catch (error) {
            console.log(error)
        } finally {
            handleStopLoading()
        }
    };

    return (
        <Page title="Create event">
            <FormProvider methods={methods} onSubmit={handleSubmit(handleOnSubmit)}>
                <Container>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Thêm quảng cáo mới
                        </Typography>
                        <Stack direction={'row'} spacing={1}>
                            <Button
                                type="button"
                                onClick={handleCancelClick}
                                color="error"
                                variant="contained"
                                startIcon={<Iconify icon="iconoir:cancel" />}
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={isSubmitting}
                                // onClick={handleOnSubmit}
                                type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
                                Save
                            </Button>
                        </Stack>
                    </Stack>
                    <Card>
                        <CardContent>
                            <Grid container spacing={3} direction={{ xs: 'column-reverse', md: 'row' }}>
                                <Grid item xs={12} md={8}>
                                    <Stack spacing={2}>
                                        <RHFTextField name="title" label={'Tiêu đề'} />
                                        <RHFTextField name="url" label={'Url'} />
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Button
                                        // disabled={isSubmitting}
                                        sx={{ border: '1px dashed gray' }}
                                        color="primary"
                                        aria-label="upload picture"
                                        component="label"
                                    >
                                        <input
                                            onChange={handleAvatarChange}
                                            hidden accept="image/*" type="file" />
                                        {imageReview ? (
                                            <img
                                                src={imageReview}
                                                alt="noimage"
                                                width={'300px'}
                                                height={'180px'}
                                                style={{ objectFit: 'cover' }}
                                            />
                                        ) : (
                                            <img
                                                src="/static/noimage.jpeg"
                                                alt="noimage"
                                                width={'300px'}
                                                height={'180px'}
                                                style={{ objectFit: 'cover' }}
                                            />
                                        )}
                                    </Button>
                                    <Typography variant="body2" display="block" sx={{opacity: '0.6'}}>Kích thước: 900x600</Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Container>
            </FormProvider>

        </Page>
    )
}

export default CreateAds